import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import axios from 'axios';
import qs from 'query-string';
import { pathOr } from 'ramda';
import { parseCtn } from "../utils/ctn-string";
import { getPasswordLocation } from "../utils/location";
import { SET_AUTH_CTN, SET_AUTH_STATE, SET_AUTH_STEP, SET_CTN_READ_FROM_URL, SET_CTN_TYPE, SET_MOBILE_ID_CAPTCHA } from "./actionTypes";
import { AUTH_STEPS, LOGIN_TYPES, MESSAGES } from "./constants";
import { SET_LOGIN_MODEL } from "../../Header2021/actions/actionTypes";
import { fetchLoginModel } from "../../Header2021/actions/account";
export var onRequestSMS = function onRequestSMS(captcha) {
  return function (dispatch, getState) {
    dispatch({
      type: SET_AUTH_STEP,
      payload: AUTH_STEPS.smsCode
    });
    dispatch({
      type: SET_AUTH_STATE,
      payload: {
        fetchingSMS: true
      }
    });
    var ctn = pathOr('', ['external', 'authorization', 'authCtn'], getState());
    var bisUrl = pathOr('', ['external', 'loginModel', 'bisUrl'], getState());
    var url = "".concat(bisUrl, "/identity/generateonetimepassword?login=").concat(ctn);
    if (captcha !== undefined) {
      url = "".concat(url, "&captcha=").concat(captcha.captcha, "&captchaKey=").concat(captcha.captchaKey);
    }
    return axios.get(url, {
      transformRequest: [function (payload, headers) {
        delete headers.common['X-Requested-With'];
        delete headers['X-Requested-With'];
        delete headers['X-Request-Id'];
        delete headers['X-Request-Sign'];
        delete headers['X-Request-Timestamp'];
        return payload;
      }]
    }).then(function (response) {
      if (response.data && response.data.Status === 'OK') {
        dispatch({
          type: SET_AUTH_STATE,
          payload: {
            fetchingSMS: false
          }
        });
      } else {
        dispatch({
          type: SET_AUTH_STATE,
          payload: {
            authError: true
          }
        });
      }
    }).catch(function (error) {
      var errorCode = pathOr(null, ['response', 'data', 'ErrorCode'], error);
      if (errorCode === 'NEED_CAPTCH' || errorCode === 'ERROR_CAPTCH') {
        dispatch({
          type: SET_AUTH_STEP,
          payload: null
        });
        dispatch({
          type: SET_AUTH_STEP,
          payload: AUTH_STEPS.smsCaptcha
        });
      } else {
        dispatch({
          type: SET_AUTH_STATE,
          payload: {
            authError: true,
            errorMessage: MESSAGES[errorCode] || MESSAGES.DEFAULT
          }
        });
      }
    });
  };
};
export var onSetMobileIdCaptcha = function onSetMobileIdCaptcha(captcha) {
  return function (dispatch) {
    dispatch({
      type: SET_MOBILE_ID_CAPTCHA,
      payload: {
        mobileIdCaptcha: {
          key: null,
          captcha: null
        }
      }
    });
    if (captcha) {
      dispatch({
        type: SET_MOBILE_ID_CAPTCHA,
        payload: {
          mobileIdCaptcha: {
            key: captcha.captchaKey,
            captcha: captcha.captcha
          }
        }
      });
    }
  };
};
export var onSubmitCtn = function onSubmitCtn(ctn) {
  return function (dispatch, getState) {
    var isFTTB = pathOr(false, ['external', 'regions', 'currentRegion', 'isFTTB'], getState());
    var parsedCtn = parseCtn(ctn);
    var premiseCtn = (parsedCtn.ctnType === LOGIN_TYPES.mobile ? parsedCtn.ctn : ctn).trim();
    dispatch(fetchLoginModel(premiseCtn)).then(function (loginModel) {
      dispatch({
        type: SET_AUTH_CTN,
        payload: premiseCtn
      });
      var outerLoginType = pathOr(LOGIN_TYPES.unknown, ['loginType'], loginModel);
      var requiredSendSms = pathOr(false, ['requiredSendSms'], loginModel);
      var nextStep;
      var loginType;
      // Check for SMS sending
      if (outerLoginType === LOGIN_TYPES.mobile) {
        if (requiredSendSms) {
          loginType = outerLoginType;
        } else {
          loginType = LOGIN_TYPES.login;
        }
      } else {
        loginType = outerLoginType;
      }
      dispatch({
        type: SET_CTN_TYPE,
        payload: loginType
      });
      // Check for step
      if (loginType === LOGIN_TYPES.mobile) {
        if (isFTTB === true) {
          nextStep = AUTH_STEPS.smsInitial;
        } else {
          nextStep = AUTH_STEPS.smsCode;
          dispatch(onRequestSMS());
        }
      } else {
        nextStep = AUTH_STEPS.password;
      }
      dispatch({
        type: SET_AUTH_STEP,
        payload: nextStep
      });
    }).catch(function () {
      dispatch({
        type: SET_AUTH_STATE,
        payload: {
          authError: true
        }
      });
    });
    // }
  };
};

export var onCheckMobileIdAvailable = function onCheckMobileIdAvailable(ctn) {
  return function (dispatch) {
    var parsedCtn = parseCtn(ctn);
    var premiseCtn = (parsedCtn.ctnType === LOGIN_TYPES.mobile ? parsedCtn.ctn : ctn).trim();
    return dispatch(fetchLoginModel(premiseCtn)).then(function (_ref) {
      var requiredSendSms = _ref.requiredSendSms;
      return requiredSendSms;
    }).catch(function () {
      return false;
    });
  };
};
export var onSetLoading = function onSetLoading(loading) {
  return function (dispatch) {
    dispatch({
      type: SET_LOGIN_MODEL,
      payload: {
        loading: loading
      }
    });
  };
};
export var onResetForm = function onResetForm() {
  return function (dispatch) {
    dispatch({
      type: SET_AUTH_STEP,
      payload: AUTH_STEPS.initial
    });
    dispatch({
      type: SET_AUTH_CTN,
      payload: ''
    });
    dispatch({
      type: SET_CTN_TYPE,
      payload: LOGIN_TYPES.unknown
    });
  };
};
export var onSwitchForm = function onSwitchForm(step, needLoginModel) {
  return function (dispatch, getState) {
    if (needLoginModel) {
      dispatch(fetchLoginModel());
    }
    var ctn = pathOr('', ['external', 'authorization', 'authCtn'], getState());
    dispatch({
      type: SET_AUTH_CTN,
      payload: ctn.trim()
    });
    dispatch({
      type: SET_AUTH_STEP,
      payload: step
    });
  };
};
export var onSetLoginType = function onSetLoginType() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : LOGIN_TYPES.unknown;
  return function (dispatch) {
    dispatch({
      type: SET_CTN_TYPE,
      payload: type
    });
  };
};
export var onStepChange = function onStepChange(step) {
  return function (dispatch, getState) {
    dispatch({
      type: SET_AUTH_STEP,
      payload: step
    });
    if (
    // eslint-disable-next-line sonarjs/no-identical-expressions
    pathOr(null, ['authorization', 'mobileIdCaptcha', 'key'], getState().external) || pathOr(null, ['authorization', 'mobileIdCaptcha', 'key'], getState().external)) {
      dispatch({
        type: SET_MOBILE_ID_CAPTCHA,
        payload: {
          mobileIdCaptcha: {
            key: null,
            captcha: null
          }
        }
      });
    }
  };
};
export var onSubmitMobileId = function onSubmitMobileId(onSuccess, onError) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var _getState$external$au, _getState$external, _getState$external$au2;
      var additionalParams, mobileIdCaptcha, mobileIdData, ctn, _yield$axios$post, data, _e$response, _e$response$data, _e$response2, _e$response2$data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            additionalParams = '';
            mobileIdCaptcha = (_getState$external$au = getState().external.authorization) === null || _getState$external$au === void 0 ? void 0 : _getState$external$au.mobileIdCaptcha;
            mobileIdData = (_getState$external = getState().external) === null || _getState$external === void 0 ? void 0 : _getState$external.mobileIdData;
            ctn = (_getState$external$au2 = getState().external.authorization) === null || _getState$external$au2 === void 0 ? void 0 : _getState$external$au2.authCtn;
            if ((mobileIdCaptcha !== null && mobileIdCaptcha !== void 0 && mobileIdCaptcha.key || (mobileIdCaptcha === null || mobileIdCaptcha === void 0 ? void 0 : mobileIdCaptcha.key) === '') && mobileIdCaptcha !== null && mobileIdCaptcha !== void 0 && mobileIdCaptcha.captcha) {
              additionalParams = "?captcha=".concat(mobileIdCaptcha.captcha, "&captchaKey=").concat(mobileIdCaptcha.key);
            }
            _context.prev = 5;
            _context.next = 8;
            return axios.post("".concat(mobileIdData.bisUrl, "/identity/mobileid").concat(additionalParams), {
              ctn: parseCtn(ctn).ctn
            }, {
              withCredentials: mobileIdData.bisIncludeCredentials,
              transformRequest: [function (payload, headers) {
                delete headers.common['X-Requested-With'];
                delete headers['X-Requested-With'];
                delete headers['X-Request-Id'];
                delete headers['X-Request-Sign'];
                delete headers['X-Request-Timestamp'];
                return payload;
              }]
            });
          case 8:
            _yield$axios$post = _context.sent;
            data = _yield$axios$post.data;
            if (onSuccess) {
              onSuccess(data);
            }
            if (data.validationPassed && data.mobileidtoken) {
              dispatch(onSwitchForm(AUTH_STEPS.mobileId));
              dispatch(onSetLoginType(LOGIN_TYPES.mobile));
            }
            _context.next = 17;
            break;
          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](5);
            if ((_context.t0 === null || _context.t0 === void 0 ? void 0 : (_e$response = _context.t0.response) === null || _e$response === void 0 ? void 0 : (_e$response$data = _e$response.data) === null || _e$response$data === void 0 ? void 0 : _e$response$data.ErrorCode) === 'NEED_CAPTCH' || (_context.t0 === null || _context.t0 === void 0 ? void 0 : (_e$response2 = _context.t0.response) === null || _e$response2 === void 0 ? void 0 : (_e$response2$data = _e$response2.data) === null || _e$response2$data === void 0 ? void 0 : _e$response2$data.ErrorCode) === 'ERROR_CAPTCH') {
              dispatch(onStepChange(null));
              dispatch(onStepChange(AUTH_STEPS.mobileIdCaptcha));
            } else if (onError) {
              onError();
            }
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[5, 14]]);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var onGetCtnFromUrl = function onGetCtnFromUrl(dispatch, getState) {
  var ctn = qs.parse(window.location.search).loginAutofillCtn;
  try {
    ctn = atob(ctn);
  } catch (er) {
    ctn = '';
  }
  if (!ctn || pathOr(false, ['authorization', 'ctnReadFromUrl'], getState().external)) {
    return;
  }
  dispatch({
    type: SET_CTN_READ_FROM_URL
  });
  dispatch({
    type: SET_AUTH_CTN,
    payload: ctn
  });
};

// eslint-disable-next-line consistent-return
export var onResetPassword = function onResetPassword() {
  return function (dispatch, getState) {
    var _getState$external$au3 = getState().external.authorization,
      authStep = _getState$external$au3.authStep,
      loginType = _getState$external$au3.loginType;
    var loginModel = getState().external.loginModel;
    if (loginModel) {
      return getPasswordLocation({
        recoverPasswordUrl: loginModel.recoverPasswordUrlString,
        step: authStep,
        loginType: loginType
      });
    }
    dispatch(fetchLoginModel()).then(function (_ref3) {
      var recoverPasswordUrlString = _ref3.recoverPasswordUrlString;
      getPasswordLocation({
        recoverPasswordUrl: recoverPasswordUrlString,
        step: authStep,
        loginType: loginType
      });
    });
  };
};